import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getPractitioner } from 'src/view-models/Practitioner'
import AssistantCard from './components/AssistantCard'
import EditAssistant from './components/EditAssistant'
import Loading from 'src/components/loading/Loading'
import NotFound from 'src/components/not-found/NotFound'
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'

const AssistantDetails = () => {
  const dispatch = useAppDispatch()
  const {pathname} = useLocation()
  const {practitioner:assistant} = useAppSelector((state)=>state.practitioner)
  const id = pathname.split("/")[3]
  const [isEdit,setIdEdit] = useState(false)
  const [isLoading,setIsLoading] = useState(true)

  useEffect(()=>{
    const fetchAssistant = async () => {
      await getPractitioner(id,dispatch)
      setIsLoading(false)
    }
    fetchAssistant()
  },[id,isEdit])

  if(isLoading){
    return <Loading />
  }

  if(!assistant && !isLoading){
    return <NotFound page='assistant' />
  }

  return (
    <Box px={4} py={2} rounded={4}>
      <Flex mb={4} flexDirection={{base:'column',md:'row'}} alignItems={{base:'flex-start',md:'center'}} justifyContent='space-between' gap={4} >
        <Box>
          <Text color='#4E5D78' fontWeight={700} fontSize={30} >{assistant?.first_name}</Text>
          <Text color='#4E5D78'>Sur cette page, vous pouvez gérer tous les aspects concernant {assistant?.first_name} Assistant </Text>
        </Box>
        <Button colorScheme='blue' onClick={()=>setIdEdit((prev)=>!prev)} >{isEdit ? 'Annuler la modification':'Edit the Assistant'}</Button>
      </Flex>
      {isEdit ? (
        <Box backgroundColor='white' p={8} boxShadow='md' >
          <EditAssistant  setIsEdit={setIdEdit} data={assistant} />
        </Box>
      ) : (
        <AssistantCard data={assistant} />
      )}
    </Box>
  )
}

export default AssistantDetails